import CoachProfileTestimonials from './coach-profile-testimonials'

export default CoachProfileTestimonials
